import React from 'react';
import styles from './styles';

const JobListing = ({ onSelectRole }) => (
  <section style={styles.jobListing}>
    <div className="text-center mb-8">
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="w-px h-6 bg-silver/30"></div>
        <p className="text-xs font-mono tracking-[0.3em] text-silver/50 uppercase">
          Sacred Roles
        </p>
        <div className="w-px h-6 bg-silver/30"></div>
      </div>
      <h2 className="text-2xl font-light text-silver">Choose Your Path</h2>
    </div>
    <div className="space-y-4">
      {["Software Engineer", "Product Designer"].map((role) => (
        <button
          key={role}
          onClick={() => onSelectRole(role)}
          style={{ ...styles.button, marginBottom: '0.5rem' }}
          className="w-full text-left p-6 bg-black/30 border border-silver/20 rounded-xl hover:border-silver/40 hover:bg-black/50 transition-all duration-500 font-light"
        >
          <div className="flex items-center justify-between">
            <span className="text-silver">{role}</span>
            <div className="w-2 h-2 bg-silver/60 rounded-full"></div>
          </div>
        </button>
      ))}
      <button
        onClick={() => onSelectRole("custom")}
        className="w-full text-left p-6 bg-black/30 border border-silver/10 rounded-xl hover:border-silver/30 hover:bg-black/50 transition-all duration-500 font-light text-silver/70 hover:text-silver"
      >
        <div className="flex items-center justify-between">
          <span>Propose Your Sacred Role</span>
          <div className="w-2 h-2 bg-silver/40 rounded-full"></div>
        </div>
      </button>
    </div>
  </section>
);


export default JobListing;
